import React from "react";
import Banner from "../components/Banner";
import { Link } from "react-router-dom";

export default function Error() {
  return (
    <Banner title="404" subtitle="Page Not Found">
      <Link to="/" className="btn-primary">
        Return Home
      </Link>
    </Banner>
  );
}
